/** Styled Markdown
 *  A styled version of the markdown component from
 *  @see https://github.com/remarkjs/react-markdown
 */
import { cx } from '@algolia/ui-components-shared'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

interface IStyledMarkDown {
  content: string
  paragraphTextAlign?: 'left' | 'center'
}

export const StyledMarkDown: React.FC<IStyledMarkDown> = ({
  content,
  paragraphTextAlign = 'left'
}) => {
  const textAlignmentClass =
    paragraphTextAlign === 'center' ? 'u-text-center' : 'u-text-left'
  const paragraphStyles = `[&_p]:lens-overline-text ${textAlignmentClass}`

  const listStyles = '[&_ul]:u-list-disc [&_ul]:u-ml-[1rem] [&_li]:lens-small-paragraph-text'
  const strongStyles = '[&_strong]:u-font-bold [&_strong]:u-text-secondary-900'

  const headerStyles = `
    [&_h1]:lens-overline-text [&_h2]:lens-overline-text [&_h3]:lens-overline-text
    [&_h4]:lens-overline-text [&_h5]:lens-overline-text [&_h6]:lens-overline-text
  `
  return (
    <ReactMarkdown
      className={cx(
        'b-Markdown | c-flow | u-flow-space-inner--200 !u-list-disc u-text-left u-text-4 u-text-secondary-800',
        paragraphStyles,
        listStyles,
        strongStyles,
        headerStyles
      )}
    >
      {content}
    </ReactMarkdown>
  )
}

export default StyledMarkDown
